export default "__VITE_ASSET__CFdXNM2r__"